import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import {
  deleteDataList,
  getData,
  postData,
} from "src/utils/axios/serverHelper";
import { formatDate } from "src/utils/string/stringUtil";

import {
  KSK2130_R01DetailDto,
  KSK2130_R01HeaderDto,
} from "./Dto_KSK2130_R01";
import { KSK2130_R01Filter } from "./Store_KSK2130_R01";

const baseUrl = `${config.apiUrl}/KSK2130_R01`;

const getKSK2130_R01Params = (filter: Partial<KSK2130_R01Filter>) => ({
  compCd: filter.compCd,
  workplaceCd: filter.workplaceCd,
  orderEmp: filter.orderEmp,
  startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
  endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
});

export const getKSK2130_R01List = (
  option: string,
  filter: Partial<KSK2130_R01Filter>,
) =>
  getData<ResponseDto<KSK2130_R01HeaderDto[]>>(`${baseUrl}/${option}`, {
    params: getKSK2130_R01Params(filter),
  });

export const getKSK2130_R01DetailList = (productOrderNo: string) =>
  getData<ResponseDto<KSK2130_R01DetailDto[]>>(
    `${baseUrl}/detail/${productOrderNo}`,
  );

export const getKSK2130_R01LotList = (productOrderNo: string) =>
  getData<ResponseDto<KSK2130_R01DetailDto[]>>(`${baseUrl}/lot`, {
    params: { productOrderNo },
  });

export const postKSK2130_R01 = (data: KSK2130_R01DetailDto[]) =>
  postData<
    KSK2130_R01DetailDto[],
    ResponseDto<KSK2130_R01DetailDto[]>
  >(`${baseUrl}/detail`, data);

export const deleteKSK2130_R01 = (data: KSK2130_R01DetailDto[]) =>
  deleteDataList<KSK2130_R01DetailDto[], ResponseDto<void>>(
    `${baseUrl}/detail`,
    data,
  );
